import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

import userimg from "../../assets/images/user.png";
import userIcon from "assets/svgs/customerIcon.svg";
// import logoIcon from "../../assets/images/logo-icon.svg";
// import logoInfo from "../../assets/images/logo-info.svg";
import { FormattedMessage, useIntl } from "react-intl";
import { Context } from "../../wrapper";
import Arabic from "../../lang/ar.json";
import English from "../../lang/en.json";

const Header = ({ logo }) => {
  const sidebarToggle = () => {
    document.querySelector("body").classList.toggle("sidebarToggled");
    document.querySelector(".overlay-s").classList.toggle("fire");
    document.querySelector("html").classList.toggle("offScroll");
  };

  const context = useContext(Context);

  const handleChangeLangOnClick = (locale) => {
    localStorage.setItem("lang", locale);

    context.setLocale({
      lang: locale,
      messages: locale === "ar" ? Arabic : English,
    });

    document.body.setAttribute("dir", locale === "ar" ? "rtl" : "ltr");
    document.documentElement.lang = locale === "ar" ? "ar" : "en";
    document.querySelector("title").textContent =
      locale === "ar" ? "لوحة التحكم" : "Dashboard";
  };

  const { locale } = useIntl();

  return (
    <>
      <div className="main-head">
        <div className="logo">
          <div className="inner">
            <NavLink to="/">
              <div className="header_logo__">
                <img src={logo} alt="" />
              </div>
              {/*               
              <div className="logo-icon">
                <img src={logoIcon} alt="" />
              </div>
              <div className="logo-info">
                <img src={logoInfo} alt="" />
              </div> */}
            </NavLink>
          </div>
        </div>
        <div className="head-wrp">
          <div className="burgerBtn">
            <button className="toggleSidebar" onClick={sidebarToggle}>
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.75 1C15.75 0.585786 15.4142 0.25 15 0.25H6C5.58579 0.25 5.25 0.585786 5.25 1C5.25 1.41421 5.58579 1.75 6 1.75H15C15.4142 1.75 15.75 1.41421 15.75 1Z"
                  fill="#fcb858"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H9C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13Z"
                  fill="#fcb858"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.75 7C15.75 6.58579 15.4142 6.25 15 6.25H1C0.585787 6.25 0.25 6.58579 0.25 7C0.25 7.41421 0.585787 7.75 1 7.75H15C15.4142 7.75 15.75 7.41421 15.75 7Z"
                  fill="#fcb858"
                />
              </svg>
            </button>
          </div>

          <div className="authWrap">
            {/* <div className="menu-item-has-children lang">
              <span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.92478 0.53125C4.10837 0.53125 0.206026 4.46875 0.206026 9.25C0.206026 14.0664 4.10837 17.9688 8.92478 17.9688C13.706 17.9688 17.6435 14.0664 17.6435 9.25C17.6435 4.46875 13.706 0.53125 8.92478 0.53125ZM8.5029 9.00391C8.39743 9.17969 8.22165 9.25 8.01071 9.25C7.87009 9.25 7.72946 9.32031 7.62399 9.42578L7.41306 9.63672C7.30759 9.74219 7.30759 9.91797 7.41306 10.0234L7.62399 10.2344C7.72946 10.3398 7.79978 10.4805 7.79978 10.6211V10.9375C7.79978 11.2539 7.51853 11.5 7.23728 11.5H6.99118C6.78024 11.5 6.60446 11.3945 6.49899 11.2188L5.6904 9.60156C5.62009 9.46094 5.40915 9.39062 5.26853 9.53125L4.5654 10.2344C4.45993 10.3398 4.31931 10.375 4.17868 10.375H1.96384C1.92868 10.0234 1.89353 9.63672 1.89353 9.25C1.89353 5.38281 5.02243 2.21875 8.92478 2.21875C9.66306 2.21875 10.4013 2.35938 11.0693 2.57031L9.31149 3.94141C9.13571 4.04688 9.13571 4.32812 9.34665 4.43359L9.73337 4.60938C9.90915 4.71484 10.0498 4.89062 10.0498 5.10156V7.84375C10.0498 8.01953 9.90915 8.125 9.76853 8.125H9.6279C9.52243 8.125 9.45212 8.08984 9.38181 7.98438C9.34665 7.87891 9.17087 7.87891 9.13571 7.98438L8.5029 9.00391ZM14.5498 12.8711C14.5498 13.0117 14.4795 13.1523 14.374 13.2578L14.0224 13.6094C13.917 13.7148 13.7763 13.75 13.6357 13.75H13.1084C12.9677 13.75 12.792 13.7148 12.6865 13.6094L12.2295 13.1523C12.0888 12.9766 11.8427 12.8711 11.5967 12.8711C11.4912 12.8711 11.4209 12.8711 11.3506 12.9062L10.6123 13.082C10.542 13.082 10.5068 13.1172 10.4717 13.1172H10.1201C9.94431 13.1172 9.80368 13.0469 9.69821 12.9414L9.27634 12.5195C9.24118 12.4844 9.20603 12.4141 9.20603 12.3086V11.957C9.20603 11.8516 9.27634 11.7461 9.38181 11.7109L10.7529 11.1484C10.8232 11.1133 10.8935 11.0781 10.9638 11.043L11.8076 10.4453C11.8427 10.4102 11.9131 10.4102 11.9482 10.4102H12.3701C12.5107 10.4102 12.6162 10.4453 12.6513 10.5508L12.8271 11.0078C12.8623 11.0781 12.8974 11.1133 12.9677 11.1133H13.1084C13.1435 11.1133 13.2138 11.0781 13.2138 11.0078L13.3896 10.4805C13.3896 10.4453 13.4599 10.4102 13.4951 10.4102H13.7412C13.8115 10.4102 13.8818 10.4453 13.8818 10.5508V10.9727C13.8818 11.0781 13.8818 11.1484 13.9521 11.1836L14.374 11.6055C14.4795 11.7109 14.5146 11.8516 14.5146 11.9922V12.8711H14.5498Z"
                    fill="#8C8C8C"
                  />
                </svg>
                {locale === "ar" ? "العربية" : "English"}
              </span>
              <ul className="sub-menu">
                <li>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeLangOnClick("ar");
                    }}
                  >
                    العربية
                  </a>
                </li>
                <li>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeLangOnClick("en");
                    }}
                  >
                    English
                  </a>
                </li>
              </ul>
            </div> */}
            <ul>
              <li className="menu-item-has-children">
                <Dropdown>
                  <Dropdown.Toggle>
                    <div className="au-flow">
                      <div className="au-img">
                        <img src={userimg} alt="" />
                      </div>
                      <div className="au-data">
                        <h4>
                          <FormattedMessage id={"manager"} />
                        </h4>
                      </div>
                    </div>
                    <svg
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.14376 6.13396L1.06422 2.05441C0.867468 1.85766 0.867468 1.53867 1.06422 1.34194L1.54003 0.866126C1.73645 0.66971 2.05478 0.669332 2.25166 0.865287L5.5 4.09841L8.74832 0.865287C8.9452 0.669332 9.26353 0.66971 9.45995 0.866126L9.93576 1.34194C10.1325 1.53869 10.1325 1.85768 9.93576 2.05441L5.85625 6.13396C5.65949 6.3307 5.34051 6.3307 5.14376 6.13396Z"
                        fill="black"
                      />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <NavLink to="/profile" className="dropdown-item">
                      <FormattedMessage id={"profile"} />
                    </NavLink>
                    <NavLink to="/logout" className="dropdown-item">
                      <FormattedMessage id={"logout"} />
                    </NavLink>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="overlay-s" onClick={sidebarToggle}></div>
    </>
  );
};

export default Header;
